* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: 100%;
}

.wrapper {
  display: block;
  max-width: 100%;
  height: 100%;

  gz-grid-view::part(raw-event-os-icon) {
    font-size: 20px;
    margin-right: var(--spacer);
    color: var(--chart-302-icon-buttons-titles);
  }

  gz-info-box::part(container) {
    width: fit-content;
  }
}

.controls-header {
  display: flex;
  align-items: center;

  #changeStatusSelector {
    align-self: center;

    #changeStatusButton {
      display: flex;
      .change-status-button-container {
        display: flex;
      }
      span {
        margin-left: var(--spacer);
        margin-top: 1px;
      }
    }
  }
}
